<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre3">Vorspiel</h3>
<p class="stage">Auf dem Schloß »Unserer Frauen Berg« bei Würzburg.
Die große Hofstube. Links eine Art Thron mit Baldachin. Eine Anzahl
Ritter, geharnischte und ungeharnischte, stehen abwartend oder
bewegen sich, halblaut miteinander redend. An einer Fensternische,
rechts, steht der Schreiber Gilgenessig, ein kleines, vertrocknetes
Männchen, und liest einigen Rittern aus einer Flugschrift laut vor.
Unter den Zuhörenden: Hans von Lichtenstein, ein etwa
vierzigjähriger Domherr, Heinz von Stein, Ritter, Wolf von
Hanstein, Ritter, Hans von Grumbach, Ritter.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum ersten ist unsre demütige
Bitt . . .«</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>, <span class="regie">knirschend.</span> Ei, du Speikatz! Fast demütig.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum ersten ist unsre demütige Bitt, daß eine
ganze Gemeine Macht soll haben, ihren Pfarrherrn selbst erwählen
und kiesen. Der soll uns das Evangelium predigen, lauter, klar, ohn
alle menschliche Zusätz.«</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>, <span class="regie">schnaufend.</span> Ein fast demütig und untertäniges
Supplizieren, mit Flegeln und Hauen, Spießen und Hakenbüchsen.</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Nach dem
Kirchendieb- und Ketzerpaternoster!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Dünket euch das
ein so unbillig Erfordern, ihr Herrn?</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Lies, Schreiber,
lies!</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Es riecht
hie ein wenig nach Lutherischer Grütz, Karlstattscher Suppen und
Hussitischer Pestilenz.</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Dünket euch das
so unbillig, ihr Herrn?</p>
<p class="calibre1"><span class="speaker">Hans von Grumbach</span>. Ei, leid dich,
Wolf! Das Männlein zerplatzet dir sonst vor Wut!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>, <span class="regie">laut.</span> Wie steht's in der Schrift geschrieben? »Ich
will meine Herd erlösen von ihrem Mund.« Ihr habt die Milch gessen,
euch von der Woll gekleidet, und was feist gewesen, habt ihr
gemetzget! Itzt hungert sie nach Brot und dürstet nach Wein, aber
nit nur nach Brot und Wein, sondern der Herr hat seinen Hunger und
Durst gesandt, zu hören sein Wort, lauter, klar und rein und <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page6" title="lac/gary"></a> trotz aller feisten
Bäuche und glatten Bälge, ohn alle menschliche Zusätz.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum andern, nachdem der rechte Zehnte
ufgesetzt ist im Alten Testament und im Neuen alles erfüllt, nicht
desto minder wollen wir den rechten Kornzehnt gern haben.«</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Brav dahergered't,
Junker Misträumer, fürtrefflich aufgereupzt, Gevatter
Knollfink!</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Den kleinen Zehnten wollen wir gar nit
geben.«</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Oha! Euch
hat der Teufel die Leviten gelesen!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Hochwürdiger
Herr, wollt Ihr mir eine Frage beantworten?</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Je nachdem,
Ritter!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Wohlan, stehet
dem Bischof nach levitischem Gesetz der Zehnte von allem Land zu,
warum läßt er sich nit beschneiden? <span class="regie">Sensation
bei einem Teil der Anwesenden, Gelächter bei einem
andern.</span></p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Kotz,
Junker, das mag Euch der Teufel beantworten!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Entsetzet ihr
euch, liebe Herrn? Ei! leset doch die Leviten, und wann es darinnen
nit gefodert wird, so will ich den Magister Hoogstraten zu Köln
fortan nit mehr eine verabscheuungswürdige, verfluchte Bestie
schelten!</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum dritten ist der Brauch bisher gewest,
daß sie uns für ihre Eigenleut gehalten haben . . .«</p>
<p class="stage">Bewegung, Lachen und Entrüstung unter der Mehrheit
der Anwesenden.</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Freilich wohl,
Eigenleut hat's geben, allsolange die Welt steht; da hadert mit
unserm Herrgott, der hat es so eingericht't.</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Itzt meinen
sie, daß sie es Gott wollen abtrotzen, wann sie den Teufel zum Abt
über sich setzen, und daß er werde einen jeden Lüsbühel unter ihnen
zum Herren machen.</p>
<p class="stage">Graf Wolf von Kastell kommt. Im übrigen füllt sich
der Saal mehr und mehr mit Domherren, Rittern und allerhand
Hofbeamten.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Was liest der
Schreiber?</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> ». . . der Brauch bisher gewesen, daß sie uns
<a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page7" title="lac/gary"></a> für ihre Eigenleut
gehalten haben, welches zum Erbarmen ist, angesehen, daß uns
Christus alle mit seinem kostbarlichen Blutvergießen erlöst und
erkauft hat, den Hirten gleich allsowohl als den Höchsten.«</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>, <span class="regie">nachsprechend.</span> ». . . den Hirten gleich allsowohl
als den Höchsten.«</p>
<p class="calibre1"><span class="speaker">Hans von Grumbach</span>. Dawider wäre
wohl nichts nit zu sagen, ihr Herrn.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Was leset
Ihr?</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span>. Die gründlichen und
rechten Hauptartikel aller Bauernschaft und Hintersassen der
geistlichen und weltlichen Oberkeiten, von welchen sie sich
beschwert vermeinen, auch die Handlung und Instruktion, so
vorgenommen worden sein von allen Rotten und Haufen der Bauern.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Die Zwölf
Artikel, damit sie St. Velten beschissen hat. Wo habt Ihr sie
her?</p>
<p class="calibre1"><span class="speaker">Erster Ritter</span>. Ei, fliegen sie nit
allenthalben in der Luft herum? Habt Ihr sie noch nit in Eurem
Hosensack gefunden?</p>
<p class="stage">Eine große Anzahl unter Rittern und Domherren
weist das Schriftchen vor.</p>
<p class="calibre1"><span class="speaker">Stimmen</span>. Da! Nehmt, lest!</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span>. Das Heftlein, daraus
ich euch vorlese, gestrenge Herrn, hätt ein Bote vom Götzen von
Berlichingen unlängst über die Mauer hereingereicht.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Tuet seine
Pfauenfedern gewaltig herfür, der Götz!</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Hat auch
unserm allergnädigsten Bischof und Herrn absagen und des Stifts
Lehne aufkündigen lassen.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span>. »Datum zu Amorbach uf
Donnerstag nach Misericordias Domini.«</p>
<p class="calibre1"><span class="speaker">Zweiter Ritter</span>. Habt ihr gehört,
ihr Herrn, wie greulich die Evangelischen zu Amorbach gehaust
haben? Ich war im Zwinger gegen den Glißberg, als die Türmer den
Boten anbliesen. Bin auf die Mauer gestiegen und hab mit ihm
gered't. Ist es der Köchle gewest und des Götzen von Berlichingen
Leibknecht, den ich gut gekannt hab, von einem Gesellenritt her,
den wir miteinander getan haben. »Köchle, was macht ihr«, hab ich
ihn angeschrien, »du und dein Herr? Seid ihr zu schwarzen Bauern
worden?« – »Müssen wohl, fester Junker«, hat er mir Antwort geben,
<a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page8" title="lac/gary"></a> »es sei uns lieb
oder leid; aber es ist ein Jammer, wie sie alles verwüstet haben zu
Amorbach, als die wütigen vollen Säu! Ich bin den Pfaffen mein
Lebtag gram gewest«, hat er geschrien, »aber hier ist christliche
Lieb auf türkische Art bewiesen.« – »Habt ihr euch bei den
Benediktinern eingelegt?« schrei ich ihm zu. – »Ja, fester Junker,
und es ist in der ganzen Abtei kein Nagel in einem Pfosten
blieben.«</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Kotz Leichnam!
Ihr Herrn, zu einem Scheißhausräumer wollt ich mich eh verdingen,
denn daß ich mich brauchen ließ wie der Götz und zu einem Obersten
Feldhauptmann setzen, wo nichts dann heilloses Gesindel, Spieler,
Diebsleut, Vaganten und Pfannenflicker hinter ihm drein fleugt!</p>
<p class="calibre1"><span class="speaker">Zweiter Ritter</span>. Es ist zweifelsohn,
ihr Herrn, und der Köchle hat es von Amorbach mitgebracht, Graf
Wilhelm von Henneberg hätt sich itzt auch mit den Bauern
verbrüdert.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Leider Gottes, es
ist, wie der Junker sagt. Mein Schwager hätt sich itzt auch mit dem
Gepövel vermenget. Haben ihm Dörfer, Schlösser und Abteien
verwüstet, er ist von ihnen gedrungen und gezwungen worden.
Freilich, wann sie mich schon am Schandpfahl hätten und den
Schelmenschinder mit den glühenden Eisen an mich setzten, so wollt
ich mich doch lieber dem Teufel selbst verbrüdern als mit den
rotzigen bäurischen Bluthunden.</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Das ist nun
der herrliche und zuverlässige Trost, den Grave Wilhelm unserm
gnädigen Herrn, dem Bischof Konrad, durch Schickung und Schrift so
läßlich und sicherlich zugesagt hat, daß er sich itzt mit den
Bauern verbrüdert.</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. O der elenden
Hilf, wir hätten wohl lange genug verziehen sollen, eh uns
versprochenermaßen von Henneberg war Kriegsvolk zukommen.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span>. Die Brief sind Papier
blieben.</p>
<p class="calibre1"><span class="speaker">Erster Domherr</span>. Sind in die Aschen
fallen und sind verbrannt.</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Ich aber sag
euch, ihr Herrn, der Grave Wilhelm von Henneberg verstehet die
Läufte, wir aber verstehen die Läufte nit. Was hat denn der gemeine
Adel all die Zeit von den geistlichen Herren zu befahren gehabt?!
Not, Bedrückung Leibes und der Seele.</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Und was hat
er von den Bauern zu befahren gehabt? Wollt Ihr mir das wohl sagen,
Ritter? <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page9" title="lac/gary"></a> Muß man es
Euch erzählen, Herr, wie die Bauern unlängst zu Weinsberg mit dem
gemeinen Adel gehandelt haben? Habt Ihr das wohl schon vergessen,
Ritter, daß sie wider Kriegsbrauch und Recht den Ludwig von
Helfenstein durch die Spieße gejagt haben und vierzig gefangene
Ritter und Knechte dazu? Itzt ist es landkundig worden, wie sie
allda gehauset. Haut und Haar eines Gemordeten hätt ein frommer
evangelischer Bruder auf dem Spieße herumgetragen. Ein verrucht
Weib und schwarze teuflische Hexe hätt dem Helfensteiner das
Brotmesser in den Leib stoßen und mit dem Blut und Fett, das
herausgeschweißet, ihre Schuhe geschmiert. Meinet Ihr dannoch,
Junker, daß die Bäurischen ein freundlich Gemüt tragen wider Euch?
Bei Unsrer Lieben Frauen! glaubet mir, bleiben die Bäurischen oben
liegen, so wird die Prophezei wahr, darin es heißt: der gemeine
Adel soll einstmals müssen Elend aus Essig speisen, mit Mangel
beträufeln und in bitterer Wermut arme Ritter backen.</p>
<p class="leftmarg"><span class="regie">Viele Ritter schlagen an
die Wehre, und es erschallt mehrmals der Ruf:</span> Rache für
Weinsberg!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Itzt rufet ihr:
»Rache für Weinsberg«, und Gott weiß es, daß ihr mit den
Weinsberger Mordbuben nit wollet glimpflich verfahren, wann ihr an
sie kämet. Wisset ihr aber auch, was die Bauern geschrien, als sie
Weinsberg im Sturm genommen und Ritter, Bürger und Knechte zu
Paaren trieben? »Rache für Wurzach! Rache für die siebentausend von
Wurzach!« Luget, ihr Herrn, der Truchseß hätt auch kein Erbarmen
mit ihnen gehabt und den bösen Krieg allenthalben ausschreien
lassen. Läßt auch die Profossen in sie arbeiten mit Galgen und Rad
und der Bauern beste Leut abtun, als wenn es Hühner wären. Denkt an
den frommen Prediger Jakob Wehe zu Leipheim.</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Ei, wohl und
brav, so ist es recht; es sei mit Gewalt gered't und ihnen das Maul
gestopfet, allen verfluchten, falschen, höllischen Propheten und
Schwarmgeistern, wie sie der Satan allenthalben hat auferwecket.
Heraus mit dem verfluchten, höllischen Unkraut, das er hat zwischen
den Weizen gesäet, überall und allerwegen in deutschen Landen!
Immer herausgerauft, gerissen, gestochen, gebrannt, immer
darniedergemäht, sei es lutherisch, karlstattisch, münzerisch,
hussitisch oder wiclefitisch. Der Bock ist schon viel zu weit in
Garten <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page10" title="lac/gary"></a> kommen.
Immer dareingewettert, Georg Truchseß! Sei ein echter, rechter
St. Georg und Drachentöter, so gefällt es Gott und unserer
gebenedeiten Jungfrau Maria. War es eh geschehen, die Ufruhr sollt
schwerlich also überwälzig worden sein.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum vierten ist bisher bräuchlich gewest,
daß kein armer Mann Gewalt gehabt hat, das Wildpret, Vögel oder
Fische im fließenden Wasser zu fahen. <span class="regie">Gelächter
in der Mehrzahl.</span> Welches uns ganz unziemlich und
unbrüderlich dünkt.«</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Daß euch die
Drüs, mit meinem Willen soll kein Rülze von einem Bauern in meinem
Gejaide eine Armbrust aufbringen.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum fünften sind wir auch beschweret der
Beholzung halben, dann unsre Herrschaft haben ihnen die Hölzer alle
allein geeignet. Zum sechsten ist unsre hart Beschwerung der
Frondienst halben, welche von Tag zu Tag gemehret werden und
täglich zunehmen.«</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Die Sach is itzt
so bestellt: Der Bauer will alleweil auf der faulen Haut liegen, in
der Trinkstuben sich auftun, über der Geschrift disputieren und den
Prädikanten nachlaufen. Aber der Pflug ist ihm zu schwer worden.
Wird er itzt aber bei Eiden und Pflichten gemahnt, oha, so ist er
der Junker Dörflinger und rühret sich so wenig, als hätt ihn der
Satan aus einem Leimklotz gemacht. Wendet die Herrschaft itzt aber
den Ernst vor und läßt einen aufsässigen Lauskopf und
widerspenstigen Esel in die Eisen tun – kotz Schweiß, so ist man
der allergottloseste Tyrann und Wüterich!</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span> <span class="regie">liest.</span> »Zum achten sein wir beschwert und
diejenigen, die Güter innehaben, daß dieselben Güter die Gült nit
ertragen können.«</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Das nimmt mich
nit wunder, wahrlich nit. Gebären sie sich nit schlimmer auf ihren
Gütern mit Schlemmen, Dämmen und Verprassen als der lüderlichste
Hauser von Edelmann? Da ist nichts dann Hochzeiten, Fressen,
Weinsaufen und Wiedervonsichspeien. Statt groben Zwillichs, wie es
einem groben Flegel gebühret, tragen sie Tuch aus Mecheln und
London. Ihre Weiber wollen es den Edelfrauen zuvortun an
Kleiderpracht, und manch eine hat einen Meierhof wert in einer
Ketten um den Hals. Ihre Töchter behenken sie mit Seide und Sammet,
Marder, <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page11" title="DaoH/gary"></a>
Hermelin und Goldstoff, daß ein Edelfräulein dawidergehalten einer
Stallmagd gleichsiehet.</p>
<p class="stage">Lorenz von Hutten kommt erschöpft und atemlos.</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Neue Zeitung,
ihr Herrn!</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Ist dir der Teufel
begegnet, Lorenz?!</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Gelobt sei Gott
und die heilige Anna, daß ich im Trocknen bin! Hat mir einer den
Gaul unterm Leib weggebirst, als wir beide, mein Gaul und ich,
durch die Furt wollten und mitten im Main schwammen.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Sie schießen mit
den Handrohren?</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Ei, freilich,
wißt Ihr das nit? Die Würzburger Häcker, in den Weinbergen am Main,
haben die Handrohre mit ihnen genommen und bei der Arbeit neben
sich liegen. Wenn sie eines bischöflichen Reuters etwa von ungefähr
ansichtig werden, ei nun, so machen sie Jagd auf uns, als ob wir
Antvögel wären, piff, paff, hinter dem Mäuerlein hervor. Hab ein
gut Roß, das mit dem Blei im Leib noch einen tapfren Sprung
vorwärts getan, daß ich, Gott sei gelobt, wie die Katz auf die Füße
zu stehen kam und nit, geharnischt wie ich war, im tiefen Wasser
elendiglich ersoff.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Ist denn kein
Henker meh unten zu Würzburg, der einen verdammten meuchlerischen
Mörder und Friedbrecher voneinander kann schlagen, daß der Kopf das
kleinere und der Leib das größere Teil ist?</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Ei nein. Dann
die Würzburger haben den Meister Jakob davongejagt, weil er gesagt
hat, es wird mit der Ufruhr zu Würzburg kein End nit nehmen, bevor
er nit etlichen, dem Georg Bermetter voran, die Grint abgehauen.
Dafür wollten ihn die Würzburger tot haben; so ist er itzt hie auf
der Burg mitsamt seinen Knechten.</p>
<p class="calibre1"><span class="speaker">Gilgenessig</span>. Heut ist zu Würzburg
kein Zeuge, Herr Graf, der etwas ablegen, kein Notario, der etwas
schreiben, kein Advokato, der den Prozeß formieren, kein
Stadtdiener, der angreifen, kein Richter, der examinieren, keine
Obrigkeit, die urteilen, gleichwie kein Scharfrichter ist, der
exequieren kann.</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Was ist's
für Zeitung, die Ihr bringt, fester Junker?</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Was ich für
Zeitung bringe, liebe Herrn? Nit mehr noch minder, als daß ich gute
Kundschaft hab und glaublich bericht't bin, daß alle Haufen der
Bauern uf Würzburg zu ziehn und daß, solange die Welt steht, <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page12" title="sf-bo/gary"></a> kein solches Reisen,
Webern und Inhaufenziehen gewesen ist mit Panieren, Schweinspießen,
Flegeln, Hellebarden, Handrohren, Wägen und Hakenbüchsen. Ich bin
glaublich bericht't, daß die Evangelischen von Amorbach her
unterwegs sind, daß sie ein Kruzifix mit sich tragen und geschworen
haben, wie sie das Kind im Mutterleibe wollten verderben, wenn
ihnen der Bischof, unser allergnädigster Herr, das Schloß nit wollt
gutwillig eingeben. <span class="regie">Bewegung und Erregung unter
den Rittern.</span></p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Wer vor Dräuen
stirbt, dem läutet man mit Eselsfürzen aus, ihr Herrn. Habt Ihr
noch meh solcher Botschaften, Ritter?</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Ja, Kitzingen
ist in der Brüderschaft.</p>
<p class="calibre1"><span class="speaker">Erster Ritter</span>. Potz Blau, Kitzingen
hat sich mit den Bauern verbrüdert?</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. Auf
Edelmannswort!</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>. Wird den
Markgrafen Kasimir zu Ansbach übel verdrießen!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Meinet Ihr? Mir
will viel eh scheinen, daß den ganzen bäurischen Handel zu Ansbach
kein übel Aug ansiehet. – Ist nicht der Markgraf den lutherischen
Materien zugetan, so gut wie der Henneberger? Ist es nit
landkundig, daß der Schwarzenberger, der gewaltige Ritter und
Lutheraner, zwischen Ansbach und den bäurischen Lägern Botschaft
hin und wider reitet? Es dünket mich nit unmöglich, daß
markgräfisches Geschütz mit den bäurischen Flegeln zu gleicher Zeit
hie oben anklopfet.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Meinest du uns
scheißbange zu machen, Wulf, mit überhirnischem Zeug und
Spinnstubenmärlein? Mag es den Markgrafen gelüsten als einen Fuchs
nach der feisten Gans und wär auch all sein Gemüt darauf gericht't,
des Stifts Güter zu erschnappen und als ein Herzog in Franken
Einzug zu halten auf Unserer Frauen Berg, so weiß er doch, daß es
mit dem Bundschuh just so wenig möglich sein kann, als daß man über
dem Rheinsturz bei Schaffhausen auf einen Turm steiget.</p>
<p class="stage">Sebastian von Rotenhahn, Hofmeister des Bischofs,
in Rüstung, tritt ein und durchschreitet den Raum, im Begriff sich
zum Bischof zu begeben. Man hält ihn an.</p>
<p class="calibre1"><span class="speaker">Heinz von Stein</span>. Saget, Euer
Hochgelahrt, bestätigt sich das Gerücht? Hat sich Kitzingen dem
Florian Geyer und seinen Schwarzen zugelobt? <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page13" title="Corny/gary"></a></p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Liebe,
getreue Freunde und Herrn! Habet Geduld, verziehet ein wenig.</p>
<p class="calibre1"><span class="speaker">Erster Ritter.</span> Weshalb hat man uns
berufen, Euer Edel?</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Das sollt
ihr von Seiner Liebden, unserm gnädigsten Fürsten und Herrn, in
höchsteigener Person erfahren.</p>
<p class="calibre1"><span class="speaker">Zweiter Ritter.</span> Es heißt: von allen
Seiten zögen die Gewalthaufen der Bauern wider uns, hätten
geschworen, nichts Edles leben zu lassen.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Liebe
Getreue, habet Geduld, verziehet ein wenig!</p>
<p class="calibre1"><span class="speaker">Zweiter Ritter.</span> Wird der Bischof
das Schloß zutun, oder wird er es räumen lassen?</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Ihr Herrn,
zu Weinsberg hatte der Florian Geyer leichtes Spiel, hie aber sind
festere Mauern, ein unüberwindliches Schloß, sofern wir einig sind.
Es wäre doch gar jämmerlich und schändlich, wenn wir einem so edlen
Herrn, milden, gütigen und gerechten Fürsten, wie es unser Bischof
Konrad ist, nit sollten beiständig sein. Würde auch einer
hochberühmten fränkischen Reichsritterschaft zu unauslöschlicher
Schmach und Schande gereichen.</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Wohlan, Bastian,
der Bischof ist ein frommer und gerechter Herr, und ich hab nichts
wider ihn; aber der ganze Handel hat in keinem Weg mit der Person
zu tun. Ist einstmals ein Ritter gewest, und war nie keiner ihm
gleich, stolz wie er, mutig wie er, treu und fest an die Wahrheit
gehängt. Der hat wider die Pfaffen geschrieben, solang ihm ein
Äderlein hielt: Ulrich von Hutten hat er geheißen. Ei nun, der
Hutten ist tot und hin; die Pfaffen haben ihn in Armut, Elend und
Tod gehetzt. Aber sein Werk ist blieben, seine Saat ist blieben und
stehet in Blüte. »Wach auf«, hat er geschrieben, »du edle deutsche
Freiheit«, und die edle deutsche Freiheit ist aufgewacht. Aber
itzt, Bastian, da Gott in die Sachen geschaut und sie auferwecket
hat, itzt schlafet Ihr. Dazumalen waret ihr ein Herz, du und der
Hutten. Aber alsbald er dahin ist, bist du mit ihm gestorben. Oder
willst du mir sagen, daß du noch lebst? Potz, wie hättest du deinen
Blutsbruder ungerächt können lassen! Wie hättest du dich mögen von
den Pfaffen brauchen und andern zu einem Wall auftürmen lassen
wider die . . .</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Was redest
du dich in Hitze, <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page14" title="Frank_9901/gary"></a> Wolf! Wider wen redest du, wider was redest
du? Soll eine allgemeine, große Reformation sich anfahen, wohlan,
setze ich mich dawider, setzt sich der Bischof dawider? Hat er sich
nicht vielmehr hoch erboten, wo gerechte Beschwerden seien,
dieselben zu hören, unbillige Bürden zu ringern und abzutun, allem
Folge zu tun und Statt zu lassen, was andere Fürsten, Herren und
Hintersassen beschließen und ufrichten würden? Siehest du nit, daß
es hie allein heißt, sich wider Tollheit und Raserei setzen, die
alles darniedertritt, zerstampfet und verwüstet, sauren Schweiß des
Armen, Häuser der Reichen, Schlösser, Kirchen, Schätze der Kunst
und Gelehrsamkeit? Ei, Wolf, in welche Verblendung bist du geraten!
Lebte der Ulrich von Hutten, hie sollt er neben mir stehen, so wahr
ich sein Freund bin.</p>
<p class="calibre1"><span class="speaker">Lorenz von Hutten</span>. So wahr Gott
lebet, hie stünd er neben uns.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Ja, Wolf,
so ist es, und siehe doch um dich! Hat nicht der Luther sich wider
die Bauern gewandt und wider ihre blutgierigen, höllischen Haufen
und Rotten geschrieben?</p>
<p class="stage">Der Bischof Konrad von Würzburg mit großem
Gefolge.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell,</span> <span class="regie">den Bischof zuerst gewahrend.</span> Unser allergnädigster
Herr, der Bischof Konrad zu Würzburg und Herzog von Franken, vivat
hoch!</p>
<p class="calibre1"><span class="speaker">Die Mehrzahl der Ritter.</span> Hoch!
Hoch!</p>
<p class="stage">Der Bischof begibt sich nach dem Thronsessel; das
Gefolge, darunter der junge Oberste Hauptmann, Dompropst Friedrich
von Brandenburg, gruppiert sich um ihn. Nachdem Stille eingetreten,
redet der Bischof stehend.</p>
<p class="calibre1"><span class="speaker">Bischof Konrad.</span> Liebe Freunde, ich
weiß, daß ihr es alle treulich und gut mit mir meinet als meine
Diener, Vasallen und Stiftsverwandte. So hab ich euch dann berufen
lassen, um euch kundzutun, wie ich mich in diesen geschwinden und
je länger je mehr bedrohlichen Läuften fürder zu halten gesonnen
bin.</p>
<p class="leftmarg">Es ist euch bekannt, wie dieserzeit
allenthalben in deutscher Nation sich eine Aufruhr erhebt hat und
der gemeine Mann sich bedrückt vermeinet mit unbilligen und
unträglichen Lasten.</p>
<p class="leftmarg">Als sich im März die Bauern in der Rothenburger
Landwehr zu Ohrenbach und Bretheim erhoben und rottieret, hab ich
dem Statthalter zu Mainz, auch dem Pfalzgrafen <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page15" title="Frank_9901/gary"></a> Ludwig um Hilf zugeschrieben.
Als danach Markgraf Kasimir einen Tag gen Neuenstadt
ausgeschrieben, wie man sich ufs fürderlichste und fruchtbarlichste
wider das Vornehmen der Bauern in Rüstung schickte, zu beraten, hab
ich meine Räte dorthin verordnet. Aber es ist nichts
Fruchtbarliches und Fürderliches auf dem Tag gehandelt worden. Nu
hab ich meine Ritterschaft und Landschaft beschrieben und in des
Stifts Amten ufbieten lassen.</p>
<p class="leftmarg">Haben auch meine Bauern allsogleich zu den
Wehren griffen, Reispanier ufgesteckt, Schläge und Fuhrten
vermacht, aber, als itzt am Tag ist, allein mir zuleid, nit mir
zulieb. Nachdem der Bauern unchristlich und unbrüderlich Fürnehmen
im hohen und niedern Deutschland immer bedrohlicher anwuchs und der
Florian Geyer Weinsberg im Sturm genommen, hab ich zum andern Malen
Seiner Liebden, dem Markgrafen zu Ansbach, meinem lieben Freund und
Herrn, Werbung um Hilfe tun lassen und hab ihme durch Seiner
Liebden leiblichen Bruder, unsern lieben getreuen Freund und
Dompropst <span class="regie">– dabei legt er die Hand auf Markgraf
Friedrichs Schulter –</span> Markgrave Friedrich in Person
angesucht. Ist mir aber keine tröstliche Antwort gefallen, da
Seiner Liebden nit minder bedroht ist und die gleiche Ufruhr,
Empörung und Not zu gewärtigen hat dann wir. Derweilen ist die
Sintfluß immer mehr gestiegen, hat alles überwälzet, Herrschaften,
Fürstentümer, Klöster, Burgen und Städte; hab ich mich um
Bundshülfe umgetan bei dem Bund zu Schwaben, hab meine Räte in der
Bauern Läger geschickt, hat aber alles nit mögen fruchten.</p>
<p class="leftmarg">Liebe Freunde und Herrn, es kann euch das alles
nit unbekannt sein, ingleichen, wie ich mich hoch und willig
erboten, zur Abwendung und Milderung gerechter Beschwerden meiner
bischöflichen Stadt und Landschaft. Gott weiß es, daß ich alles in
Güte zu tun bereitwillig war, damit die Sachen zu dieser Weiterung
nit erwachsen möchte, war aber alle Geschicklichkeit und Vernunft
gar umsonst, kein gütlich Wort nit gehöret, alles in Luft geblasen.
So ist es zu Würzburg dahin kommen, daß sie die Haufen der Bauern
mit Schriften zu sich geladen; Bürgerschaft und Rat sind eines
Sinns, möchten je eher je lieber zu den Bauern fallen und helfen,
unser festes Schloß ab dem Berg werfen. Nachdem ich dies alles nu
hab sehen müssen und erkannt hab, daß auch von Grave Wilhelm von
Henneberg Hilfe nit meh <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page16" title="r_a_5/gary"></a> zu gewärtigen ist, auch nichts Gewissers ist,
dann daß die Bauern vor Unserer Frauen Berg ziehen, den belägern
und zu nötigen unterstehen werden, hab ich mit meinen Räten
Gespräch halten und für gut befunden, mich auf und hinweg zu tun.
Ja, lieben Freunde, so stehe ich itzt vor euch. <span class="regie">Mit starker innerer Bewegung.</span> Von all meinem
Fürstentum und Landen ist mir nichts überblieben als dies einige
Schloß, und davon muß ich itzt auch ziehen. Gott aber mag wissen,
ob ich je wieder dareinkomme.</p>
<p class="stage">Pause der Ergriffenheit, stumme Bewegung und
Flüstern unter den Rittern.</p>
<p class="leftmarg">Es ist mir nit wenig beschwerlich,
hinwegzuziehn und so viele Fürsten, Grafen, Ritter und Knecht in
der Burg «zu verlassen. Aber es ist von mir und meinen Räten für
gut angesehen, daß ich mich hinweg und zu Pfalzgrave Ludwigen,
Kurfürsten, tue, um persönlich Hülf zu erlangen oder des
Schwäbischen Bundes zu Ulm Hülfe. Seid gewiß, daß ich keine Müh
sparen, auf nichts andres denken will bei Tag und Nacht, dann wie
ich euch erlöse aus Fahr und Ängsten, darin ich euch zurücklaß.</p>
<p class="stage">Gemurmel und Geflüster unter den Rittern.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>
<span class="regie">tritt vor</span>. Hochwürdiger Fürst und Herr!
Euer fürstlichen Gnaden Willen und Meinung haben wir vernommen und
bitten Euer fürstliche Gnaden, nit anders von uns zu denken, als
daß sich ein jeder von uns zu halten gedenkt, wie ihm nach adligen
Ehren gebührt und zusteht. <span class="regie">Entschiedene
Zustimmungsbezeugung bei der Mehrzahl</span>. Es ist keiner unter
uns Franken, der nit gewillt ist, Leib und Gut bei seinem Herzog
und Herrn zu lassen . . .</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>, <span class="regie">leise</span>. Der Teufel hat ihn zu einem Herzog in Franken
gemacht!</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>,
<span class="regie">fortfahrend</span> . . . und sich zu
gebrauchen, weil er ein'n Arm zu regen die Kraft hat.</p>
<p class="leftmarg">Meine guten Freunde, Gesellen und Brüder von
den fränkischen Adelsbänken wissen allzuwohl, was itzt auf dem
Spiel steht.</p>
<p class="leftmarg">Der Pöbel hat sich erhebt allenthalben, und wo
etwas hoch ist, da recket er seine Arme nach, da greifen sie mit
ihren unreinen Händen. Nennen sich evangelische Brüder und ihre
Einung eine christliche Brüderschaft, unserm Herrn und Seligmacher
Jesu Christo zu einem Greuel und Schmach. Hießen viel baß höllische
Brüder und ihre Einung <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page17" title="r_a_5/gary"></a> eine türkische Brüderschaft, da sie überall wüten
mit Weingärten zerreißen, Früchte zertreten, mit Mord, Brand,
Weiber schänden, Kisten fegen und Säckel leeren.</p>
<p class="leftmarg">Es ist leider am Tag, daß Fürsten, Herrn und
Gewaltigen, kurzum der Oberheit allenthalben das Schwert und das
Herz entsunken ist. Ein großer Schrecken ist in sie gefahren und
hat sie gelähmet. Keiner reichet dem andern die Hand und rühret
sich nit, bis ihm die Mauer, daran er sich lehnet, selbst zu heiß
wird.</p>
<p class="leftmarg">Gnädigster Herr, durchlauchtigster Fürst! Uns
alle hier lähmet der Schrecken nit. Wahr ist's: das Gesindel fleugt
und schneit zu, allweg, als die Fliegen im Sommer. Es ist schier,
als habe es in deutschen Landen allenthalben Bauern geregnet und
gehagelt, aber es ist der mehre Teil ein nackt, ungeniet Volk, die
den Hasen im Busen haben, Weinbuben und Tabernierer, die
zuallererst nach den Fässern und Würsten laufen und nit gewohnt
sind, einen Mann zu finden.</p>
<p class="leftmarg">Liebe, fromme Gesellen! In unsrer Besatzung ist
keiner, der nit ein Mannskerl, von unserm Obersten Hauptmann,
Markgrafen Friedrich von Brandenburg, bis herab zum allergeringsten
Buben. Laßt sie nur kommen und ihnen die harten bäurischen
Grützköpf an unsern Mauern zerstoßen. Wir wollen sie mit
Stückkugeln laus'n, daß ihnen soll angst und bange werden.</p>
<p class="calibre1"><span class="speaker">Rufe der Ritter</span>, <span class="regie">kriegerisch begeistert</span>. Her! her!</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Wir wollen
ihnen die Würzburger Osterfladen mit Pulver bestreuen und mit Pech
und Schwefel begießen. Sie sollen bleierne Birnen dabei zu
schlucken bekommen, soviel sie nur immer mögen.</p>
<p class="calibre1"><span class="speaker">Geschrei der Ritter</span>. Her! her!</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Unsere
Mauern sind fest, die Gräben tief; Zwergzäune sind ufgericht't, ein
Lichtzaun ist gemacht, Zwinger, Tor, Turm sind in gutem Stand. Wir
haben Pulver und Proviant, Wasser, Wein, Holz, Kohle, Mehl, Speck.
Wir können in Hülle und Fülle leben und uns ihrer erwehren zween
Monat und länger hinaus. Wir wissen wohl, es ist nit allein um das
Schloß getan, es ist um die ganze deutsche Nation getan. Dies ist
der Fels, Freunde; unterspület ihn die Flut, so stürzet alles nach
und versinket, und bleibet nichts über von ganzer großer deutscher
Nation dann ein Haufe elender Steine und Trümmer. <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page18" title="r_a_5/gary"></a></p>
<p class="leftmarg">Gnädigster Herr und Fürst! Gott hat uns auf
diesen Felsen gestellt, und wir wollen mit Gott ausharren, ihn
hüten und verteidigen, und wär es wider den Teufel selbst, weil wir
noch einen Blutstropfen im Leib und einen Hauch in der Brust
haben.</p>
<p class="calibre1"><span class="speaker">Bischof Konrad</span>. Das walte Gott und
der Ritter St. Georg!</p>
<p class="leftmarg"><span class="regie">Ein Tumult und
Begeisterungstaumel bricht jetzt los. Die Ritter schreien</span>
Her! Her!, <span class="regie">umarmen sich, schütteln sich die
Hände unter Tränen.</span> Vivat, Bischof Konrad! Vivat unser
Bischof und Herr! <span class="regie">und wiederum</span> Her! Her!
<span class="regie">schallt es durcheinander.</span></p>
<p class="stage">Inmitten der allgemeinen Bewegung entfernt sich
der Bischof und sein Gefolge. Dompropst Markgraf Friedrich von
Brandenburg bleibt mit kleinem Gefolge zurück.</p>
<p class="calibre1"><span class="speaker">Kunz von der Mühlen</span> <span class="regie">schreit</span>. Ich will den Florian Geyer in ein Mauseloch
prügeln.</p>
<p class="calibre1"><span class="speaker">Erster Ritter</span>. Bauer, hüt dich,
mein Roß schlägt dich!</p>
<p class="calibre1"><span class="speaker">Kunz von der Mühlen</span>. Wohl her! wir
wollen den Florian Geyer und seine Weinsberger Mordbuben in ein
Mauseloch prügeln.</p>
<p class="calibre1"><span class="speaker">Sebastian von Geyer</span>, <span class="regie">zu Wolf von Hanstein</span>. Wolf, Wolf, ich halt mich nit
länger. Soll der Bärenhäuter meinen leiblichen Bruder also
beschimpfen dürfen?</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>, <span class="regie">laut zu Kunz von der Mühlen</span>. Der Florian Geyer ist
ein so ehrlicher Ritter und Reuter von Adel als irgendeiner im
Lande zu Franken.</p>
<p class="calibre1"><span class="speaker">Kunz von der Mühlen</span>. Der Florian
Geyer ist ein halssträflicher Schuft.</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>, <span class="regie">zu Sebastian Geyer, der losfahren will</span>. Leid dich,
Sebastian; laß das gespornte Hähnlein krähen auf seinem Mist. Wann
wollt Ihr doch Euren Adelsbrief bezahlen, he, Junker
Straßenfeger?</p>
<p class="calibre1"><span class="speaker">Kunz von der Mühlen</span> <span class="regie">schreit</span>. Der Florian Geyer ist ein Ächter, ein Feind
des Kaisers und ganzer deutscher Nation. Hat zu Pavia dem Franzosen
gedient.</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>, <span class="regie">dicht an Kunz von der Mühlen</span>. Männlein, ob dir der
Henker unter deinen gepichten Haaren noch Ohren gelassen hat, das
weiß ich nit. Aber du bist ein gehelmter Esel, wann du sie nit
hast. Und wenn du nit aufhörst zu schreien, will ich dir die
Harnischhand in dein Lästermaul stopfen, daß der rote Schweiß
hernachgehet.</p>
<p class="calibre1"><span class="speaker">Sebastian von</span> <span class="speaker">Geyer</span>. Wolf, tritt beiseit. Die Gecksnase ist
<a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page19" title="Teledahner/gary"></a> von den
Bauern entloffen. Denket sich hie groß aufzutun am Hof, leicht ein
Lehen zu erschnappen, mit Gramanzen und Maulmachen. Der Teufel
geseg'n es ihm.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Friede, ihr
Herrn. Unser Oberster Hauptmann, der Markgraf Dompropst, begehrt zu
reden.</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Sebastian –!</p>
<p class="calibre1"><span class="speaker">Sebastian von Geyer</span>. Daß dich potz
Marter schänd! der Hund soll mir büßen!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Komm mit
mir!</p>
<p class="calibre1"><span class="speaker">Sebastian von Geyer</span>. Wohin?</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Der Pfaff führt
euch am Seil. Ich geh zu den Bauern. Gehst du mit?</p>
<p class="calibre1"><span class="speaker">Sebastian von Geyer</span>. Es geht nit
an, Wolf, streitet mir wider Pflicht und Gewissen.</p>
<p class="calibre1"><span class="speaker">Markgraf Friedrich</span>. Lieben Freunde,
von unserm gnädigsten Herrn zum Obersten Hauptmann über dies Schloß
gesetzt, tu ich euch kund und zu wissen, daß ich von Stund an die
Burg zutun will und zur Verteidigung beschicken. Drum welcher Lust
hat, in der Besatzung zu bleiben, der begebe sich auf den
Schloßhof. Allda wird der Eid verlesen werden, danach sich zu
halten jeder geloben und schwören soll. Wer aber nit Lust hat, uns
fürder beiständig zu sein, der trete itzt ab.</p>
<p class="stage">Wolf von Hanstein tritt, während alles still ist,
aus der Reihe.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Wo willst du hin,
Wolf?</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Dem Evangelium
einen Beistand tun.</p>
<p class="calibre1"><span class="speaker">Die Ritter</span>. Schuft, Schurk,
Verräter, Memme!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span> <span class="regie">schreit rasend zurück.</span> Fresse die Pest alle
Pfaffenknechte! Es lebe die deutsche evangelische Freiheit!</p>
<p class="calibre1"><span class="speaker">Die Ritter</span>. Hoch unser Bischof und
Herr, hoch Bischof Konrad von Würzburg!</p>
<p class="calibre1"><span class="speaker">Wolf von Hanstein</span>. Bundschuh!
Bundschuh! <span class="regie">Ab.</span> <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page20" title="MEsswein/gary"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?19e616e8